import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../lib/store/hooks';
import { Form } from 'antd';
import {
  createOptionItem,
  getParsedSelectedItems,
  getSelectedItemsLabels,
  getSelectedItemsValues,
} from '../../../lib/utils/arranges-helpers';
import { useState } from 'react';
import { useEnumArrange } from '../../tenants/hooks/useEnumArrange';
import { useStatusColumn } from '../../../features/table/helpers/useStatusColumn';
import { PRODUCT_STATUS, PRODUCTS_COLUMNS } from '../helpers/consts';
import { ActivatedStatusBodyCell } from '../../../features/table/components/ActivatedStatusBodyCell';
import { useProductsArrangeRequest } from './useProductsArrangeRequest';

const activated = 'pages.products.products.filtering.activated';
const deactivated = 'pages.products.products.filtering.deactivated';

export const useProductStatusColumn = () => {
  const { t } = useTranslation();

  const { sorting, arrangeId } = useAppSelector(({ products }) => products);

  const [form] = Form.useForm();
  const isActiveArrange = arrangeId === PRODUCTS_COLUMNS.IS_ACTIVE;

  const getItemsLabels = () => getSelectedItemsLabels(form);
  const getItemsValues = () => getSelectedItemsValues(form);

  const [filterLabel, setFilterLabel] = useState('');

  const activatedLabel = t(activated);
  const deactivatedLabel = t(deactivated);

  const allOptions = [
    createOptionItem(activatedLabel, PRODUCT_STATUS.ACTIVATED),
    createOptionItem(deactivatedLabel, PRODUCT_STATUS.DEACTIVATED),
  ];

  const { filtering } = useEnumArrange(allOptions);

  const { applyArranges, removeFilter, removeFilterValue } = useProductsArrangeRequest({
    arrangedId: PRODUCTS_COLUMNS.IS_ACTIVE,
    getFilterLabel: () => getItemsLabels().join(', '),
    getFilters: () => ({ statuses: getItemsValues() }),
    form,
    setFilterLabel,
    filterFieldName: 'activated',
    isParsedByValue: true,
  });

  return useStatusColumn({
    filtering,
    applyArranges,
    removeFilter,
    arrangedId: PRODUCTS_COLUMNS.IS_ACTIVE,
    isActiveArrange,
    form,
    filterLabel,
    sortOrder: sorting.sortOrder,
    getParsedItems: () => getParsedSelectedItems(form),
    removeFilterValue,
    columnProps: {
      width: 134,
      render: (isActive: boolean) => {
        return <ActivatedStatusBodyCell activatedStatus={isActive} />;
      },
    },
  });
};
